import { styled } from '../../../../../core/theme/styled';

export const AccountInfo = styled.div`
  font-size: ${(props) => props.theme.sizes.small};
  margin-top: ${(props) => props.theme.sizes.xxxsmall};

  &:first-child {
    margin-top: 0;
    font-size: ${(props) => props.theme.sizes.normal};
  }
`;
